import { render, staticRenderFns } from "./newsForm2.vue?vue&type=template&id=5309aa3b&scoped=true"
import script from "./newsForm2.vue?vue&type=script&lang=js"
export * from "./newsForm2.vue?vue&type=script&lang=js"
import style0 from "./newsForm2.vue?vue&type=style&index=0&id=5309aa3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309aa3b",
  null
  
)

export default component.exports